// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2PEQ4","title":"ClientReferral_title__3ifGz","itemText":"ClientReferral_itemText__k0wLH"};